import {
  FacebookIcon,
  type IconComponent,
  InstagramIcon,
  LinkedInIcon,
  SnapchatIcon,
  TiktokIcon,
  TwitterIcon,
  YouTubeIcon,
} from '@air/design-icons';

/** Keyed by the platform labels in the smart-resize presets. */
const PLATFORM_ICONS: Record<string, IconComponent> = {
  Facebook: FacebookIcon,
  Instagram: InstagramIcon,
  LinkedIn: LinkedInIcon,
  Snap: SnapchatIcon,
  TikTok: TiktokIcon,
  'X (Twitter)': TwitterIcon,
  YouTube: YouTubeIcon,
};

export const platformIcon = (platformLabel: string) => PLATFORM_ICONS[platformLabel];
